export function wait(interval) {
  return new Promise((resolve) => {
    setTimeout(resolve, interval)
  })
}

export function randomWait(min, max) {
  const interval = min + Math.floor(Math.random() * max)

  return wait(interval)
}
